module.exports = __webpack_public_path__ + "static/img/logo-qyd.09ad45e7.png";